import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

import { PaymentMethodBankRule } from '../../../models';
import { TmsWebBaseEditCreateService } from '../../base';

@Injectable({
  providedIn: 'root',
})
export class PaymentMethodBankRuleService extends TmsWebBaseEditCreateService<
  PaymentMethodBankRule,
  PaymentMethodBankRule
> {
  public refreshDetails = new Subject<void>();

  constructor() {
    super('PaymentMethodBankRule', $localize`Payment Method Bank Rule`);
  }

  getForPaymentMethod(id: string): Observable<PaymentMethodBankRule[]> {
    return this.httpService.get<PaymentMethodBankRule[]>(`${this.apiUrl}/GetForPaymentMethod?id=${id}`);
  }
}
